import { render, staticRenderFns } from "./BannerDetail3.vue?vue&type=template&id=88491fe8&scoped=true&"
import script from "./BannerDetail3.vue?vue&type=script&lang=js&"
export * from "./BannerDetail3.vue?vue&type=script&lang=js&"
import style0 from "./BannerDetail3.vue?vue&type=style&index=0&id=88491fe8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88491fe8",
  null
  
)

export default component.exports